export default __webpack_public_path__ + "static/media/telegram-blue.232ebb03.svg";